import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { UserGuard } from 'auth-data-access';
import { LoginFormComponent, PasswordFormComponent, ResetPasswordComponent } from 'auth-ui';
import { FooterResolver } from 'footer';
import { MainNavigationResolver } from 'navigation';
import { ExternalUrlsGuard } from '../route-guards/external-urls.guard';
import { AuthComponent } from './auth.component';

const childrenRoutes: Routes = [
  {
    path: 'login',
    component: LoginFormComponent,
    canActivate: [
      ExternalUrlsGuard,
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
        inject(UserGuard).authenticatedGuard(false, route, state),
    ],
  },
  {
    path: 'create-password',
    component: PasswordFormComponent,
    canActivate: [
      ExternalUrlsGuard,
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
        inject(UserGuard).authenticatedGuard(true, route, state),
    ],
  },
  {
    path: 'reset-password/:refId',
    component: ResetPasswordComponent,
  },
  {
    path: 'login-tv',
    component: LoginFormComponent,
    data: { isTv: true },
    canActivate: [
      ExternalUrlsGuard,
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
        inject(UserGuard).authenticatedGuard(false, route, state),
    ],
  },
];

export const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: childrenRoutes,
    resolve: { mainNavigation: MainNavigationResolver, footer: FooterResolver },
  },
];
